import React, { Component } from "react"
import Layout from "../../../components/layout"

import AboutBountyContest from "./aboutBountyContest"
import RegistrationBountyContest from "./registrationBountyContest"
import WelcomeBountyContest from "./welcomeBountyContest"
import AgreementBountyContest from "./agreementBountyContest"
import DeclineBountyContest from "./declineBountyContest"
import ToolBountyContest from "./toolBountyContest"
import SubmissionBountyContest from "./submissionBountyContest"
import AnnounceBountyContest from "./announceBountyContest"
import ThankyouBountyContest from "./thankyouBountyContest"

import axios from "axios"
import FileDownload from "js-file-download"

import CTABanner from "../../../components/common/ctaBanner/ctaBanner"
import * as styles from "./ironCAPBountyContest.module.scss"
import HowItWorks from "../../../components/sections/howItWorks/howItWorks"
import "../../../static.css"
import { LearnMoreTagline } from "../../common/typography/banner-tagline"
import { TM } from "../../common/typography/trademark"

class IronCAPBountyContest extends Component {
  constructor(props) {
    super(props)

    this.state = {
      errorMsg: null,
      selectedFile: null,
      agreementID: "",
      userID: "",
      mode: "announcement",
      enableAgreement: false,
      open: false,
      email: "",
      firstname: "",
      lastname: "",
      logintype: "",
      token: "",
      photo: "",
      submissionlastDt: null,
      submissionTotal: null,
      answerSubmitted: false,
      submissionText: null,
      errorTool: null,
      errorSubmission: null,
      resultMatched: null,
      subscription: "y",
      app: "contest",
      appState: "expire",
      weChatCode: "",
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.closeModalWithAccept = this.closeModalWithAccept.bind(this)
    this.handleAcceptAgreement = this.handleAcceptAgreement.bind(this)
    this.handleDeclineAgreement = this.handleDeclineAgreement.bind(this)
    this.handleReturnToWelcome = this.handleReturnToWelcome.bind(this)
    this.handleReturnToAgreement = this.handleReturnToAgreement.bind(this)
    this.handleEncryption = this.handleEncryption.bind(this)
    this.handleDecryption = this.handleDecryption.bind(this)
    this.handleEncryptionBinary = this.handleEncryptionBinary.bind(this)
    this.handleDecryptionBinary = this.handleDecryptionBinary.bind(this)
    this.handleSubmission = this.handleSubmission.bind(this)
    this.closeModalWithSubmission = this.closeModalWithSubmission.bind(this)
    this.onChangeUploadFileHandler = this.onChangeUploadFileHandler.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.handleLastSubmissionData = this.handleLastSubmissionData.bind(this)
    this.handleEnableSubmissionButton = this.handleEnableSubmissionButton.bind(
      this
    )
    this.handleValidateHex = this.handleValidateHex.bind(this)
    this.handleOptOutMarketing = this.handleOptOutMarketing.bind(this)

    this.handleWeChatLogin = this.handleWeChatLogin.bind(this)
  }

  componentDidMount() {
    let self = this

    const u = typeof window !== "undefined" ? window.location.href : ""
    let lang = u.includes("ironcap-bountycontest/ct") ? "ct" : "en"

    let url = this.getApiURL("deadline")

    axios
      .get(url, { params: { lang: lang } })
      .then(function(response) {
        if (
          response.data.state === "registration" ||
          response.data.state === "contest"
        ) {
          self.setState({
            appState: response.data.state,
            open: false,
            mode: "welcome",
          })
        }
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  handleWeChatLogin(code, type) {
    var data = {
      logintype: "w",
      app: this.state.app,
      lang: this.props.lang,
      code: code,
    }

    let url = this.getApiURL("wechat/login")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        let results = response.data

        let firstName = results.nickname
          .split(" ")
          .slice(0, -1)
          .join(" ")
        let lastName = results.nickname
          .split(" ")
          .slice(-1)
          .join(" ")

        if (firstName === "") {
          firstName = results.nickname
          lastName = "_"
        }

        self.setState({
          photo: results.headimgurl,
          email: results.openid,
          firstname: firstName,
          lastname: lastName,
          logintype: "w",
          token: "-1",
          weChatCode: code,
        })

        self.register(type)
      })
      .catch(function(error) {})
  }

  handleOptOutMarketing(event) {
    let subscript = event.target.checked ? "n" : "y"
    this.setState({ subscription: subscript })
  }

  handleLogout() {
    this.setState({ mode: "welcome" })
  }

  openModal() {
    this.setState({ open: true })
  }

  closeModal() {
    this.setState({ answerSubmitted: false, open: false })
  }

  closeModalWithAccept() {
    var data = {
      id: this.state.userID,
      subscription: this.state.subscription,
      logintype: this.state.logintype,
      token: this.state.token,
      app: this.state.app,
      lang: this.props.lang,
    }
    let url = this.getApiURL("subscription")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        // let results = response.data
        self.setState({ open: false, mode: "agreement" })
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }

        if (error && error.response && error.response.status === 400) {
          self.setState({ errorMsg: error.response.data.message })
        }
      })
  }

  getExtension(filename) {
    var i = filename.lastIndexOf(".")
    return i < 0 ? "" : filename.substr(i).toLowerCase()
  }

  onChangeUploadFileHandler(e) {
    if (".pdf" !== this.getExtension(e.target.files[0].name)) {
      this.setState({
        selectedFile: null,
        errorSubmission:
          this.props.lang === "ct"
            ? "請上傳有效的 pdf 文件"
            : "Please upload valid pdf file",
      })
      return
    }

    if (e.target.files[0].size < 500000) {
      this.setState({ selectedFile: e.target.files[0], errorSubmission: null })
    } else {
      this.setState({
        selectedFile: null,
        errorSubmission:
          this.props.lang === "ct"
            ? "最大允許的文件: 500KB"
            : "Maximum allowed file size: 500KB",
      })
    }
  }

  handleEnableSubmissionButton(event) {
    this.setState({ submissionText: event.target.value.trim() })
  }

  closeModalWithSubmission() {
    const data = new FormData()
    let txtIn = document.getElementById("description")
    data.append("id", this.state.userID)
    data.append("agreement_id", this.state.agreementID)
    data.append("logintype", this.state.logintype)
    data.append("token", this.state.token)
    data.append("description", txtIn.value)
    data.append("file", this.state.selectedFile)
    data.append("app", this.state.app)
    data.append("lang", this.props.lang)

    var self = this
    self.setState({ errorSubmission: null })

    let url = this.getApiURL("submission")

    axios
      .post(url, data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then(function(response) {
        self.handleLastSubmissionData()

        self.setState({
          answerSubmitted: true,
          resultMatched: response.data.match,
        })
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 400) {
          self.setState({ errorSubmission: error.response.data.message })
        }

        if (error && error.response && error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }

        // console.log(error);
      })
  }

  handleEncryption(e) {
    e.preventDefault()

    let txtIn = document.getElementById("textIn")
    let encOut = document.getElementById("encOut")

    var data = {
      id: this.state.userID,
      agreement_id: this.state.agreementID,
      logintype: this.state.logintype,
      token: this.state.token,
      input: txtIn.value,
      convert: "e",
      out: "text",
      app: this.state.app,
      lang: this.props.lang,
    }

    let url = this.getApiURL("contesttool")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        let results = response.data
        encOut.value = results.id
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 400) {
          self.setState({ errorTool: error.response.data.message })
        }

        if (error && error.response && error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }
      })
  }

  handleValidateHex(e) {
    let txtIn = e.target

    let orig_input = txtIn.value.trim().replace(/0x/gi, "")
    orig_input = orig_input.replace(/(?:\\[rn]|[\r\n]+)+/g, "")
    orig_input = orig_input.replace(/\s/g, "")

    let match = orig_input.match(/[^A-Fa-f0-9]/g)

    if (match) {
      this.setState({
        errorTool:
          this.props.lang === "ct"
            ? "請輸入16進制值的字節 (例如: 486c6f23ef...)"
            : "Please enter hex value (e.g. 486c6f23ef....)",
      })
      return
    }

    let input = orig_input.replace(/[^A-Fa-f0-9]/g, "")

    if (input.length % 2) {
      if (this.props.lang === "ct") {
        this.setState({ errorTool: "十六進制值的長度必須為偶數" })
      } else {
        this.setState({ errorTool: "Length of hex value must be even number" })
      }

      return
    }

    this.setState({ errorTool: null })
  }

  handleEncryptionBinary(e) {
    e.preventDefault()

    let txtIn = document.getElementById("textIn")

    let orig_input = txtIn.value.trim().replace(/0x/gi, "")
    orig_input = orig_input.replace(/(?:\\[rn]|[\r\n]+)+/g, "")
    orig_input = orig_input.replace(/\s/g, "")

    let match = orig_input.match(/[^A-Fa-f0-9]/g)

    if (match) {
      this.setState({
        errorTool:
          this.props.lang === "ct"
            ? "請輸入16進制值的字節 (例如: 486c6f23ef...)"
            : "Please enter hex value (e.g. 486c6f23ef....)",
      })
      return
    }

    let input = orig_input.replace(/[^A-Fa-f0-9]/g, "")

    if (input.length % 2) {
      // alert ("Error: cleaned hex string length is odd.");
      if (this.props.lang === "ct") {
        this.setState({ errorTool: "十六進制值的長度必須為偶數" })
      } else {
        this.setState({ errorTool: "Length of hex value must be even number" })
      }
      return
    }

    var buffer = Buffer.from(input, "hex")

    var len = Buffer.byteLength(buffer)

    if (len > 128) {
      if (this.props.lang === "ct") {
        this.setState({ errorTool: "最多允許128個字節" })
      } else {
        this.setState({ errorTool: "Max 128 bytes are allowed" })
      }

      return
    }

    var data = {
      id: this.state.userID,
      agreement_id: this.state.agreementID,
      logintype: this.state.logintype,
      token: this.state.token,
      input: input,
      convert: "e",
      out: "binary",
      app: this.state.app,
      lang: this.props.lang,
    }

    let url = this.getApiURL("contesttool")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        let bufferOut = Buffer.from(response.data, "hex")

        FileDownload(bufferOut, "encrypted.bin")
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 400) {
          self.setState({ errorTool: error.response.data.message })
        }

        if (error && error.response && error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }
      })
  }

  handleDecryption(e) {
    e.preventDefault()

    let encIn = document.getElementById("encIn")
    let txtOut = document.getElementById("txtOut")

    var data = {
      id: this.state.userID,
      agreement_id: this.state.agreementID,
      logintype: this.state.logintype,
      token: this.state.token,
      input: encIn.value,
      convert: "d",
      out: "text",
      app: this.state.app,
      lang: this.props.lang,
    }

    let url = this.getApiURL("contesttool")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        let results = response.data
        txtOut.value = results.id
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 400) {
          self.setState({ errorTool: error.response.data.message })
        }

        if (error && error.response && error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }
      })
  }

  handleDecryptionBinary(e) {
    e.preventDefault()

    let encIn = document.getElementById("encIn")

    let orig_input = encIn.value.trim().replace(/0x/gi, "")
    orig_input = orig_input.replace(/(?:\\[rn]|[\r\n]+)+/g, "")
    orig_input = orig_input.replace(/\s/g, "")

    let match = orig_input.match(/[^A-Fa-f0-9]/g)

    if (match) {
      this.setState({
        errorTool:
          this.props.lang === "ct"
            ? "請輸入16進制值的字節 (例如: 486c6f23ef...)"
            : "Please enter hex value (e.g. 486c6f23ef....)",
      })
      return
    }

    let input = orig_input.replace(/[^A-Fa-f0-9]/g, "")

    if (input.length % 2) {
      // alert ("Error: cleaned hex string length is odd.");

      if (this.props.lang === "ct") {
        this.setState({ errorTool: "十六進制值的長度必須為偶數" })
      } else {
        this.setState({ errorTool: "Length of hex value must be even number" })
      }

      return
    }

    var buffer = Buffer.from(input, "hex")

    var len = Buffer.byteLength(buffer)

    if (len > 1024) {
      if (this.props.lang === "ct") {
        this.setState({ errorTool: "最多允許1024個字節" })
      } else {
        this.setState({ errorTool: "Max 1024 bytes are allowed" })
      }

      return
    }

    var data = {
      id: this.state.userID,
      agreement_id: this.state.agreementID,
      logintype: this.state.logintype,
      token: this.state.token,
      input: input,
      convert: "d",
      out: "binary",
      app: this.state.app,
      lang: this.props.lang,
    }

    let url = this.getApiURL("contesttool")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        let bufferOut = Buffer.from(response.data, "hex")
        FileDownload(bufferOut, "decrypted.bin")
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 400) {
          self.setState({ errorTool: error.response.data.message })
        }

        if (error && error.response && error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }
      })
  }

  handleAcceptAgreement() {
    var data = {
      id: this.state.userID,
      accepted: "y",
      logintype: this.state.logintype,
      token: this.state.token,
      app: this.state.app,
      lang: this.props.lang,
    }
    let url = this.getApiURL("agreement")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        let results = response.data
        self.setState({ mode: "accept", agreementID: results.id })
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }

        if (error && error.response && error.response.status === 400) {
          self.setState({ errorMsg: error.response.data.message })
        }
      })
  }

  handleDeclineAgreement() {
    var data = {
      id: this.state.userID,
      accepted: "n",
      logintype: this.state.logintype,
      token: this.state.token,
      app: this.state.app,
      lang: this.props.lang,
    }

    let url = this.getApiURL("agreement")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        let results = response.data
        self.setState({ mode: "decline", agreement_id: results.id })
      })
      .catch(function(error) {
        console.log(error)
        // console.log(error);
      })
  }

  handleReturnToAgreement() {
    this.setState({ mode: "agreement" })
  }

  handleReturnToWelcome() {
    this.setState({ mode: "welcome" })
  }

  // this is for popup , used in two places.
  handleSubmission() {
    this.setState({
      selectedFile: null,
      resultMatched: null,
      errorSubmission: null,
      open: true,
      submissionText: null,
    })
  }

  handleLastSubmissionData() {
    var data = {
      id: this.state.userID,
      agreement_id: this.state.agreementID,
      logintype: this.state.logintype,
      token: this.state.token,
      app: this.state.app,
      lang: this.props.lang,
    }
    let url = this.getApiURL("submission/list")
    let self = this

    axios
      .post(url, data)
      .then(function(response) {
        let results = response.data
        self.setState({
          submissionlastDt: results.lastrec,
          submissionTotal: results.total,
        })
      })
      .catch(function(error) {
        if (error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }
      })
  }

  componentClicked = () => {}

  showWelcome() {
    const windowGlobal = typeof window !== "undefined" && window
    if (windowGlobal) {
      windowGlobal.scrollTo(0, 0)
    }
    if (this.state.mode === "welcome") {
      return (
        <React.Fragment>
          <WelcomeBountyContest
            openModal={this.openModal}
            responseGoogle={this.responseGoogle}
            responseFacebook={this.responseFacebook}
            responseGoogleLogin={this.responseGoogleLogin}
            responseFacebookLogin={this.responseFacebookLogin}
            errorMsg={this.state.errorMsg}
            lang={this.props.lang}
            handleWeChatLogin={this.handleWeChatLogin}
          />

          <RegistrationBountyContest
            open={this.state.open}
            email={this.state.email}
            firstname={this.state.firstname}
            lastname={this.state.lastname}
            closeModal={this.closeModal}
            closeModalWithAccept={this.closeModalWithAccept}
            mode={this.state.mode}
            handleOptOutMarketing={this.handleOptOutMarketing}
            logintype={this.state.logintype}
            lang={this.props.lang}
          />
        </React.Fragment>
      )
    }

    if (this.state.mode === "announcement") {
      return (
        <AnnounceBountyContest
          openModal={this.openModal}
          responseGoogle={this.responseGoogle}
          responseFacebook={this.responseFacebook}
          responseGoogleLogin={this.responseGoogleLogin}
          responseFacebookLogin={this.responseFacebookLogin}
          errorMsg={this.state.errorMsg}
          lang={this.props.lang}
        />
      )
    }

    if (this.state.mode === "agreement") {
      return (
        <AgreementBountyContest
          mode={this.state.mode}
          handleAcceptAgreement={this.handleAcceptAgreement}
          handleDeclineAgreement={this.handleDeclineAgreement}
          lang={this.props.lang}
        />
      )
    }

    if (this.state.mode === "decline") {
      return (
        <DeclineBountyContest
          mode={this.state.mode}
          handleReturnToAgreement={this.handleReturnToAgreement}
          handleReturnToWelcome={this.handleReturnToWelcome}
          lang={this.props.lang}
        />
      )
    }

    if (
      this.state.mode === "accept" &&
      this.state.appState === "registration"
    ) {
      return (
        <ThankyouBountyContest
          mode={this.state.mode}
          email={this.state.email}
          logintype={this.state.logintype}
          photo={this.state.photo}
          handleLogout={this.handleLogout}
          lang={this.props.lang}
          firstname={this.state.firstname}
          lastname={this.state.lastname}
        />
      )
    }
    if (this.state.mode === "accept" && this.state.appState === "contest") {
      return (
        <React.Fragment>
          <ToolBountyContest
            mode={this.state.mode}
            handleEncryption={this.handleEncryption}
            handleDecryption={this.handleDecryption}
            handleEncryptionBinary={this.handleEncryptionBinary}
            handleDecryptionBinary={this.handleDecryptionBinary}
            handleSubmission={this.handleSubmission}
            email={this.state.email}
            logintype={this.state.logintype}
            firstname={this.state.firstname}
            lastname={this.state.lastname}
            photo={this.state.photo}
            handleLogout={this.handleLogout}
            submissionlastDt={this.state.submissionlastDt}
            submissionTotal={this.state.submissionTotal}
            handleLastSubmissionData={this.handleLastSubmissionData}
            handleValidateHex={this.handleValidateHex}
            errorTool={this.state.errorTool}
            lang={this.props.lang}
          />

          <SubmissionBountyContest
            open={this.state.open}
            email={this.state.email}
            firstname={this.state.firstname}
            lastname={this.state.lastname}
            closeModal={this.closeModal}
            closeModalWithSubmission={this.closeModalWithSubmission}
            onChangeUploadFileHandler={this.onChangeUploadFileHandler}
            mode={this.state.mode}
            answerSubmitted={this.state.answerSubmitted}
            handleEnableSubmissionButton={this.handleEnableSubmissionButton}
            submissionText={this.state.submissionText}
            submissionTotal={this.state.submissionTotal}
            selectedFile={this.state.selectedFile}
            errorSubmission={this.state.errorSubmission}
            resultMatched={this.state.resultMatched}
            lang={this.props.lang}
          />
        </React.Fragment>
      )
    }
  }

  getApiURL(param) {
    return `${process.env.DEMO_SERVER_API_URL}/${param}`
  }

  register(type) {
    var data = {
      email: this.state.email,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      logintype: this.state.logintype,
      token: this.state.token,
      app: this.state.app,
      lang: this.props.lang,
    }

    let url = this.getApiURL("register")
    var self = this

    axios
      .post(url, data)
      .then(function(response) {
        let results = response.data

        if (results.agreement_id && results.agreement_id > 0) {
          self.setState({
            userID: results.id,
            agreementID: results.agreement_id,
            mode: "accept",
            errorMsg: null,
          })
        } else {
          if (type === "reg") {
            self.setState({
              userID: results.id,
              agreementID: results.agreement_id,
              open: true,
              errorMsg: null,
            })
          } else {
            self.setState({
              errorMsg: (
                <>
                  You must first register to the IronCAP
                  <TM /> Bounty Contest to use this option
                </>
              ),
            })
          }
        }
      })
      .catch(function(error) {
        if (error && error.response && error.response.status === 440) {
          self.setState({ mode: "welcome" })
        }

        if (error && error.response && error.response.status === 400) {
          self.setState({ errorMsg: error.response.data.message })
        }
      })
  }

  declineAgreement() {
    var data = {
      id: this.user_id,
      accepted: "n",
      logintype: this.state.logintype,
      token: this.state.token,
      app: this.state.app,
      lang: this.props.lang,
    }

    let url = this.getApiURL("agreement")

    axios
      .post(url, data)
      .then(function(response) {
        console.log(response)
        //alert("Saved successfully");
      })
      .catch(function(error) {
        console.log(error)
        // console.log(error);
      })
  }

  responseFacebook = response => {
    console.log(response)
    if (response.email) {
      this.setState({
        photo: response.picture.data.url,
        email: response.email,
        firstname: response.first_name,
        lastname: response.last_name,
        logintype: "f",
        token: response.accessToken,
      })
      this.register("reg")
    }
  }

  responseFacebookLogin = response => {
    console.log(response)
    if (response.email) {
      this.setState({
        photo: response.picture.data.url,
        email: response.email,
        firstname: response.first_name,
        lastname: response.last_name,
        logintype: "f",
        token: response.accessToken,
      })
      this.register("login")
    }
  }

  responseGoogle = response => {
    console.log(response)
    if (response.profileObj) {
      this.setState({
        photo: response.profileObj.imageUrl,
        email: response.profileObj.email,
        firstname: response.profileObj.givenName,
        lastname: response.profileObj.familyName,
        logintype: "g",
        token: response.accessToken,
      })
      this.register("reg")
    }
  }

  responseGoogleLogin = response => {
    console.log(response)
    if (response.profileObj) {
      this.setState({
        photo: response.profileObj.imageUrl,
        email: response.profileObj.email,
        firstname: response.profileObj.givenName,
        lastname: response.profileObj.familyName,
        logintype: "g",
        token: response.accessToken,
      })
      this.register("login")
    }
  }

  render() {
    return (
      <Layout>
        <input type="hidden" name="acctType" value={this.state.logintype} />
        <input type="hidden" name="token" value={this.state.token} />

        <div id={styles.carouselContainer}>{this.showWelcome()}</div>

        <AboutBountyContest lang={this.props.lang} />
        <HowItWorks lang={this.props.lang} />
        <CTABanner
          tagline={LearnMoreTagline}
          CTA="video"
          CTADetail="how video"
          lang={this.props.lang}
        />
      </Layout>
    )
  }
}

export default IronCAPBountyContest
